import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
// import { Tree } from 'primeng/tree';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
// import { reserveSlots } from '@angular/core/src/render3/instructions';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  visible: boolean = false;
  _message: AlertMessage;
  private messageBoxSender = new Subject<AlertMessage>();
  private messageBoxReceiver = new Subject<AlertMessage>();  
  Sender = this.messageBoxSender.asObservable();
  Receiver = this.messageBoxReceiver.asObservable();

  constructor() {

  }

  public send(message: AlertMessage) {
    this.messageBoxSender.next(message);
  }

  public __receive(message: AlertMessage) {
    this.messageBoxReceiver.next(message);
  }

}

export enum AlertSeverity {
  Debug,
  Information,
  Warning,
  Error,
  Fatal,
  Success
}

export enum AlertTypes {
  Confirm,
  YesNo,
  YesNoCancel,
  Toast
}

export enum AlertResponseTypes {
  None,
  Confirmed,
  Yes,
  No,
  Cancel
}

export enum AlertPositions {
  Default,
  top,
  bottom,
  left,
  right,
  TopLeft,
  BottomLeft,
  TopRight,
  BottomRight
}

export class AlertOptions {
  public BoxType: AlertTypes;
  public Position: AlertPositions;
  public IsModal: boolean = true;
  public IsDraggable: boolean = true;
  public Heading: string;

  constructor() {
    this.BoxType = AlertTypes.Confirm;
    this.Position = AlertPositions.Default;
  }
}

export interface IErrorResult {
  Message: string;
  InnerError: IErrorResult;
}

export class AlertMessage {  

  public Response: AlertResponseTypes = AlertResponseTypes.None;
  
  constructor(
    private Key: string,
    public Message: string,
    public Severity: AlertSeverity = AlertSeverity.Debug,
    public Options?: AlertOptions
  ) {
  }

  public static getOnHttpError(key: string, message: string, r: HttpErrorResponse, a?: AlertOptions): AlertMessage {

    let em: string;

    if (r.error instanceof ErrorEvent) {
      em = 'Local error : ', r.error.message;
    } else {
      em = 'Server error ' + r.status;

      let result: IErrorResult = r.error;
      let indenter: string = '<span class="m-1"></span>';
      let indent: string = '';

      while (result != undefined && result != null) {
        if (indent == '') {
          em = em + ' : <br/>' + result.Message;
        } else {
          em = em + ' : <br/>' + indent + result.Message;
        }
        result = result.InnerError;
        indent = indent + indenter;
      }
    }

    let m = new AlertMessage(key, em, AlertSeverity.Error, a);
    return m;

    //let s: string = "Error HTTP " + r.status;
    //if (a == undefined || a == null) {
    //  a = new AlertOptions();
    //  a.Heading = s;
    //} else if (a.Heading == undefined || a.Heading == null) {
    //  a.Heading = s;
    //} 

    //let msg: string = message;

    //if (r != undefined && r != null && r.status == 0) {
    //  msg = msg + ' : <br/>' + "No server response!";
    //}

    //if (r.status != 0 && r.error != undefined && r.error != null) {
    //  alert(r.error);
    //  let result: IErrorResult = r.error;
    //  let indenter: string = '<span class="m-1"></span>';
    //  let indent: string = '';
      
    //  while (result != undefined && result != null) {
    //    if (indent == '') {
    //      msg = msg + ' : <br/>' + result.Message;
    //    } else {
    //      msg = msg + ' : <br/>' + indent + result.Message;
    //    }
    //    result = result.InnerError;
    //    indent = indent + indenter;
    //  }
    //} 

    //let m = new AlertMessage(key, msg, AlertSeverity.Error, a);
    //return m;
  }

  public getKey() {
    return this.Key;
  }
}


@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  @ViewChild('showcarrierratesPopup') showcarrierratesPopup: TemplateRef<any>;

  DiagTypes = AlertTypes;
  Severity = AlertSeverity;
  Message: AlertMessage;

  _mode: AlertTypes = AlertTypes.Confirm;;
  _display: boolean = false;  
  _position: string;
  _isDrag: boolean = true;
  _isModal: boolean = true;
  _isResize: boolean = true;
  _isMaximizable: boolean = false;

  _severity: AlertSeverity = AlertSeverity.Debug;
  _isToast: boolean = false;
  _heading: string;
  _msg: string;
  _faIconClass: string;
  _faIconColor: string;

  constructor(private alertService: AlertService, private messageService: MessageService,private dialog : MatDialog) {
    alertService.Sender.subscribe((message) => {
      this.Message = message;
      this._show();
    }, (err) => {
      alert(err);
    }, () => {

    });
  }

  private _show() {
    this._isToast = false;
    if (this.Message != null) {
      this._msg = this.Message.Message;
      this._severity = this.Message.Severity;

      switch (this._severity) {
        case AlertSeverity.Debug:
          this._faIconColor = "text-dark";
          this._faIconClass = "fa-info-circle";
          break;
        case AlertSeverity.Information:
          this._faIconColor = "text-info";
          this._faIconClass = "fa-info-circle";
          break;
        case AlertSeverity.Warning:
          this._faIconColor = "text-warning";
          this._faIconClass = "fa-exclamation-circle";
          break;
        case AlertSeverity.Error:
          this._faIconColor = "text-danger";
          this._faIconClass = "fa-times-circle";
          break;
        case AlertSeverity.Fatal:
          this._faIconColor = "text-danger";
          this._faIconClass = "fa-times-circle";
          break;
        case AlertSeverity.Success:
          this._faIconColor = "text-success";
          this._faIconClass = "fa-check-circle";
          break;
      }

      this._heading = AlertSeverity[this._severity];          
      var options = this.Message.Options;

      if (options != null) {
        if (options.Position != AlertPositions.Default) {
          this._position = AlertPositions[options.Position];
          //alert(this._message.Options);
        }
        if (options.Heading != undefined) {         
          this._heading = options.Heading;
        }
        if (options.BoxType != undefined && options.BoxType != null) {
          if (options.BoxType == AlertTypes.Toast) {
            this._isToast = true;
          } else {
            this._mode = options.BoxType;
          }
        }
      }

      if (this._isToast) {
        let toast_severity: string;
        switch (this._severity) {
          case AlertSeverity.Debug:
            toast_severity = "info";
            break;
          case AlertSeverity.Information:
            toast_severity = "info";
            break;
          case AlertSeverity.Warning:
            toast_severity = "warn";
            break;
          case AlertSeverity.Error:
            toast_severity = "error";
            break;
          case AlertSeverity.Fatal:
            toast_severity = "error";
            break;
          case AlertSeverity.Success:
            toast_severity = "success";
            break;
        }
        this.messageService.add({ severity: toast_severity, summary: this._heading, detail: this._msg });
      } else {
        this._display = true;
        let dialogRef = this.dialog.open(this.showcarrierratesPopup);

      }
      
    }    
  }

  confirm() {
    this.Message.Response = AlertResponseTypes.Confirmed;
    this.close();
  }

  yes() {
    this.Message.Response = AlertResponseTypes.Yes;
    this.close();
  }

  no() {    
    this.Message.Response = AlertResponseTypes.No;
    this.close();
  }

  cancel() {
    this.Message.Response = AlertResponseTypes.Cancel;
    this.close();
  }

  close() {
    this._display = false;
    this.dialog.closeAll();
    this.alertService.__receive(this.Message);
  }

  onToastClose() {
    this.messageService.clear();
    this.Message.Response = AlertResponseTypes.Cancel;
    this.alertService.__receive(this.Message);
  }

  ngOnInit() {
  }
}
